import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskIssuetypesWorkflowRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-issuetypes-workflow',
	path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
	exact: true,
};
